<template>
    <div style="padding-top: 100px;" id="detailPageID" class="detail_page_scale">
        <div class="use_exchange_detail">
            <div style="font-size: 30px;font-weight: 500;margin-bottom: 24px;">{{ t("detail.title") }}</div>
            <div style="margin-left: 60px;">
                <img :src=imgs1[lang] width="300px" alt="">
            </div>
            <div class="use_up_box">
                <img src="../assets/use_up.svg" width="30px" alt="">
            </div>
            <div style="margin-left: 20px;margin-bottom: 40px;">
                <img :src=imgs2[lang] width="260px" alt="">
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref } from "vue";

import { useI18n } from "vue-i18n";

const { locale, t } = useI18n();
const imgs1 = {
    zh: new URL('@/assets/use_one_zh.webp', import.meta.url).href,
    en: new URL('@/assets/use_one_en.webp', import.meta.url).href,
};

const imgs2 = {
    zh: new URL('@/assets/use_two_zh.webp', import.meta.url).href,
    en: new URL('@/assets/use_two_en.webp', import.meta.url).href,
};

const lang = ref("zh");
if (locale.value != 'zh-CN' && locale.value != 'zh') {
    lang.value = "en";
}

</script>

<style scoped>
.detail_page_scale {
    /* width: 100%; */
    /* padding-top: 100px; */
}

#detailPageID::-webkit-scrollbar {
    display: none;
}

.use_exchange_detail {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.use_up_box {
    display: flex;
    justify-content: center;
    height: 100px;
    margin: 16px 0;
    /* margin-right: 70px; */
}
</style>